import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import AuditSection from "@/components/landing/AuditSection";
import Process from "@/components/landing/Process";
import Packages from "@/components/landing/Packages";
import WhyChoose from "@/components/landing/WhyChoose";
import Industries from "@/components/landing/Industries";
import TallyForm from "@/components/landing/TallyForm";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <main data-testid="landing-page" className="bg-white text-slate-900">
      <Header />
      <Hero />
      <Stats />
      <About />
      <Services />
      <AuditSection />
      <Process />
      <Packages />
      <WhyChoose />
      <Industries />
      <TallyForm />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
